// Official Vyom Studio logo. Do NOT substitute or recolor — renders the brand asset as-is.
export function Logo({ className = "", height = 30, showWord = true }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} data-testid="vyom-logo">
      <img
        src="/brand/logo-white.png"
        alt="Vyom Studio"
        style={{ height }}
        className="w-auto select-none drop-shadow-[0_0_12px_rgba(124,112,255,0.35)]"
        draggable={false}
      />
      {showWord && (
        <span className="font-display font-bold tracking-tight text-white leading-none">
          Vyom <span className="text-[#7C70FF]">Studio</span>
        </span>
      )}
    </span>
  );
}
